import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'reactstrap';
import EirBundleCardTile from './EirBundleCardTile';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import { css } from 'emotion';
import { htmlWidget, LargeBusiness } from '../../Constants';

function ToggleContent(props) {

    const renderContent = (Content) => {
        return { __html: Content };
    }
    //To get background based on device
    const getBackgroundImage = () => {
        if (isMobile && !isTablet) {
            return (props.imageMobile) ? props.imageMobile.path : '';
        }
        return (props.backgroundImage) ? props.backgroundImage.path : '';
    }

    useEffect(() => {

        //Logic to display same height for  the MPP.  
        if (props !== undefined) {
            setTimeout(() => {
                var MPP = document.querySelectorAll(".three_six_MPP");
                var Array = [];
                for (var i = 0; i < MPP.length; i++) {
                    Array.push(parseInt(MPP[i].clientHeight));
                }
                if (!isMobileOnly) {
                    for (var i = 0; i < MPP.length; i++) {
                        if (Math.max(...Array) == 4) {
                            MPP[i].classList.add("hidden");
                        }
                        else {
                            MPP[i].style.height = (Math.max.apply(Math, Array) + "px");
                        }
                    }
                }
            }, 2000);
        }

    })

    const getBackgroundColor = () => {
        if (isMobile && !isTablet) {
            return (props.mobileBackgroundColor) ? props.mobileBackgroundColor : '';
        }
        return (props.backgroundColor) ? props.backgroundColor : '';
    }

    //Code for sequential display of tiles in mobile view
    var UserEnteredListFromProps = (props.toggle.MobileSequence !== undefined) ? props.toggle.MobileSequence : '';
    var UserEnteredArr = UserEnteredListFromProps.split(",");

    if (UserEnteredListFromProps !== undefined && UserEnteredListFromProps.length > 1 && props.toggle.desktoptiles.length == UserEnteredArr.length) {
        var getListFromProps = props.toggle.desktoptiles;
        var MobileSeqArr = [];
        for (var i = 0; i < UserEnteredArr.length; i++) {
            MobileSeqArr.push(getListFromProps[UserEnteredArr[i] - 1]);
        }
    }
    else {
        var MobileSeqArr = [];
        MobileSeqArr = props.toggle.desktoptiles;
    }

    const lbTile = LargeBusiness.isLBSite ? "lb-card-tile" : ""


    return (
        <div className={`bundle-card-tile-main ${lbTile}`}>
            {(!isMobile || isTablet) &&
                <div className='pt-4 pb-3'
                    style={{
                        backgroundImage: "url(" + getBackgroundImage() + ")",
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: getBackgroundColor(),
                    }}
                >
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row className="justify-content-center">
                            {props.toggle.desktoptiles.map((tile, i) => {
                                return (

                                    <Col key={i} className={'three-six-desktop mt-mb-30 ' + ((props.toggle.desktoptiles.length == 2) ? 'col-4' : (props.toggle.desktoptiles.length == 4) ? 'col-3' : 'col-4')} >
                                        {/* code for Most popular plan*/}
                                        {
                                            <div className={htmlWidget+` three_six_MPP pt-1 ${props.backgroundColor ? 'no-shadow' : ''} ` + ((tile.mostPopularPlanCopy != undefined && tile.mostPopularPlanCopy.length < 1) ? 'hide ' : (css` background: ${tile.MPPBackgroundColor}`))}
                                                dangerouslySetInnerHTML={renderContent(tile.mostPopularPlanCopy)}>
                                            </div>
                                        }
                                        <Card className={`three_six_card ${props.backgroundColor ? 'no-shadow' : ''}`}
                                            style={(tile.tileBorderColor === "" || tile.tileBorderColor === undefined ) ? { border: "solid 4px #ffffff" } : { border: `solid 4px` + tile.tileBorderColor }}>
                                            <EirBundleCardTile image={tile.image.path}
                                                iconTextTiles={tile.textTiles}
                                                id={props.id}
                                                index={i}
                                                title={tile.title}
                                                text={tile.text}
                                                alt={tile.altText}
                                                cta={tile.cta}
                                                ctaOutline={tile.OutlineColorCTA}
                                                ctaHover={tile.HoverColorCTA}
                                                ctaFont={tile.FontColorCTA}
                                                ctaFontHover={tile.FontColorHoverCTA}
                                                ctaAlignment={tile.AlignmentCTA}
                                                arrow={tile.ArrowImage}
                                                arrowHover={tile.ArrowHoverImage}
                                                currency={tile.currency}
                                                tileBorderColor={tile.tileBorderColor}
                                                enableAccordion={tile.enableAccordion}>
                                            </EirBundleCardTile>
                                        </Card>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                    </Container>
                </div>

            }
            {isMobile && !isTablet &&
                <div className='pt-4 pb-3' style={{
                    backgroundImage: "url(" + getBackgroundImage() + ")",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: getBackgroundColor(),
                }} >

                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row>
                            {MobileSeqArr.map((tile, i) => {
                                return (
                                    <Col className='three-six-mobile col-12 mt-mb-30 mobile-single-tile'  key={i}>
                                        {/* code for Most popular plan*/}
                                        <div className={htmlWidget+` three_six_MPP pt-1 ${props.backgroundColor ? 'no-shadow' : ''} ` + ((tile.mostPopularPlanCopy != undefined && tile.mostPopularPlanCopy.length < 1) ? 'hide ' : (css` background: ${tile.MPPBackgroundColor}`))}
                                            dangerouslySetInnerHTML={renderContent(tile.mostPopularPlanCopy)}>
                                        </div>

                                        <Card className={`three_six_card ${props.backgroundColor ? 'no-shadow' : ''}`}
                                            style={(tile.tileBorderColor === "") ? { border: "#ffffff" } : { border: `solid 4px` + tile.tileBorderColor }}>
                                            <EirBundleCardTile image={tile.image.path}
                                                iconTextTiles={tile.textTiles}
                                                id={props.id}
                                                index={i}
                                                title={tile.title}
                                                text={tile.text}
                                                alt={tile.altText}
                                                cta={tile.cta}
                                                ctaOutline={tile.OutlineColorCTA}
                                                ctaHover={tile.HoverColorCTA}
                                                ctaFont={tile.FontColorCTA}
                                                ctaFontHover={tile.FontColorHoverCTA}
                                                ctaAlignment={tile.AlignmentCTA}
                                                arrow={tile.ArrowImage}
                                                arrowHover={tile.ArrowHoverImage}
                                                currency={tile.currency}
                                                enableAccordion={tile.enableAccordion}>
                                            </EirBundleCardTile>
                                        </Card>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                    </Container>
                </div>
            }
        </div>
    );
}
export default ToggleContent;

